import { render, staticRenderFns } from "./ConsumerDashboardSmartPrepaid.vue?vue&type=template&id=0b5d71c6&scoped=true&"
import script from "./ConsumerDashboardSmartPrepaid.vue?vue&type=script&lang=js&"
export * from "./ConsumerDashboardSmartPrepaid.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDashboardSmartPrepaid.vue?vue&type=style&index=0&id=0b5d71c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d71c6",
  null
  
)

export default component.exports